import { FC } from 'react';
import AlertDialog from 'src/app/common/components/AlertDialog';
import BatchFileList from './components/BatchFileList/BatchFileList';

const BatchFilesPage: FC = () => {
  return (
    <>
      <BatchFileList />
      <AlertDialog />
    </>
  );
};

export default BatchFilesPage;
